// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1gEYl","header":"MessagesList_header__3Piv7","chat":"MessagesList_chat__1Eeej"};